export var MarketDataProvider;
(function (MarketDataProvider) {
    MarketDataProvider[MarketDataProvider["alpaca"] = 1] = "alpaca";
    MarketDataProvider[MarketDataProvider["binance"] = 2] = "binance";
    MarketDataProvider[MarketDataProvider["kaiko"] = 3] = "kaiko";
    MarketDataProvider[MarketDataProvider["databento"] = 4] = "databento";
    MarketDataProvider[MarketDataProvider["polygon"] = 5] = "polygon";
    MarketDataProvider[MarketDataProvider["internalBackfill"] = 6] = "internalBackfill";
    MarketDataProvider[MarketDataProvider["coinbase"] = 7] = "coinbase";
})(MarketDataProvider || (MarketDataProvider = {}));
export var MarketDataFeed;
(function (MarketDataFeed) {
    MarketDataFeed[MarketDataFeed["iex"] = 1] = "iex";
    MarketDataFeed[MarketDataFeed["sip"] = 2] = "sip";
    MarketDataFeed[MarketDataFeed["otc"] = 3] = "otc";
    MarketDataFeed[MarketDataFeed["binanceSpot"] = 4] = "binanceSpot";
    MarketDataFeed[MarketDataFeed["kaikoTrades"] = 5] = "kaikoTrades";
    MarketDataFeed[MarketDataFeed["databentoDirect"] = 6] = "databentoDirect";
    MarketDataFeed[MarketDataFeed["coinbaseExchange"] = 7] = "coinbaseExchange";
})(MarketDataFeed || (MarketDataFeed = {}));
export var BarOrigin;
(function (BarOrigin) {
    BarOrigin[BarOrigin["vendorMinuteBar"] = 1] = "vendorMinuteBar";
    BarOrigin[BarOrigin["aggregatedFromTrades"] = 2] = "aggregatedFromTrades";
    BarOrigin[BarOrigin["aggregatedFromLowerBars"] = 3] = "aggregatedFromLowerBars";
    BarOrigin[BarOrigin["backfilled"] = 4] = "backfilled";
})(BarOrigin || (BarOrigin = {}));
export var MarketDataQualityFlag;
(function (MarketDataQualityFlag) {
    MarketDataQualityFlag[MarketDataQualityFlag["missingTradeCount"] = 1] = "missingTradeCount";
    MarketDataQualityFlag[MarketDataQualityFlag["missingBarVwap"] = 2] = "missingBarVwap";
    MarketDataQualityFlag[MarketDataQualityFlag["vendorConditionFiltered"] = 4] = "vendorConditionFiltered";
    MarketDataQualityFlag[MarketDataQualityFlag["partialCoverage"] = 8] = "partialCoverage";
    MarketDataQualityFlag[MarketDataQualityFlag["fallbackSource"] = 16] = "fallbackSource";
})(MarketDataQualityFlag || (MarketDataQualityFlag = {}));
export var StrengthGroup;
(function (StrengthGroup) {
    StrengthGroup["veryLow"] = "Very Low";
    StrengthGroup["low"] = "Low";
    StrengthGroup["medium"] = "Medium";
    StrengthGroup["high"] = "High";
    StrengthGroup["veryHigh"] = "Very High";
    StrengthGroup["unknown"] = "Unknown";
})(StrengthGroup || (StrengthGroup = {}));
export var StrengthGroupWithNeutral;
(function (StrengthGroupWithNeutral) {
    StrengthGroupWithNeutral["veryLow"] = "Very Low";
    StrengthGroupWithNeutral["low"] = "Low";
    StrengthGroupWithNeutral["medium"] = "Medium";
    StrengthGroupWithNeutral["high"] = "High";
    StrengthGroupWithNeutral["veryHigh"] = "Very High";
    StrengthGroupWithNeutral["neutral"] = "Neutral";
})(StrengthGroupWithNeutral || (StrengthGroupWithNeutral = {}));
export var StrengthGroupWithNegative;
(function (StrengthGroupWithNegative) {
    StrengthGroupWithNegative["veryLow"] = "Very Low";
    StrengthGroupWithNegative["low"] = "Low";
    StrengthGroupWithNegative["medium"] = "Medium";
    StrengthGroupWithNegative["high"] = "High";
    StrengthGroupWithNegative["veryHigh"] = "Very High";
    StrengthGroupWithNegative["unknown"] = "Unknown";
    StrengthGroupWithNegative["negative"] = "Negative";
})(StrengthGroupWithNegative || (StrengthGroupWithNegative = {}));
export var StrengthGroupWithNegativeAndZero;
(function (StrengthGroupWithNegativeAndZero) {
    StrengthGroupWithNegativeAndZero["veryLow"] = "Very Low";
    StrengthGroupWithNegativeAndZero["low"] = "Low";
    StrengthGroupWithNegativeAndZero["medium"] = "Medium";
    StrengthGroupWithNegativeAndZero["high"] = "High";
    StrengthGroupWithNegativeAndZero["veryHigh"] = "Very High";
    StrengthGroupWithNegativeAndZero["unknown"] = "Unknown";
    StrengthGroupWithNegativeAndZero["negative"] = "Negative";
    StrengthGroupWithNegativeAndZero["zero"] = "Zero";
})(StrengthGroupWithNegativeAndZero || (StrengthGroupWithNegativeAndZero = {}));
export var RatingGroup;
(function (RatingGroup) {
    RatingGroup["poor"] = "Poor";
    RatingGroup["average"] = "Average";
    RatingGroup["good"] = "Good";
    RatingGroup["veryGood"] = "Very Good";
    RatingGroup["excellent"] = "Excellent";
})(RatingGroup || (RatingGroup = {}));
export var AboveBelowGroup;
(function (AboveBelowGroup) {
    AboveBelowGroup["above"] = "Above";
    AboveBelowGroup["below"] = "Below";
    AboveBelowGroup["at"] = "At";
    AboveBelowGroup["veryAbove"] = "Very Above";
    AboveBelowGroup["veryBelow"] = "Very Below";
    AboveBelowGroup["unknown"] = "Unknown";
})(AboveBelowGroup || (AboveBelowGroup = {}));
export var RsiGroupEnum;
(function (RsiGroupEnum) {
    RsiGroupEnum["veryOverbought"] = "Very Overbought";
    RsiGroupEnum["overbought"] = "Overbought";
    RsiGroupEnum["slightlyOverbought"] = "Slightly Overbought";
    RsiGroupEnum["neutral"] = "Neutral";
    RsiGroupEnum["slightlyOversold"] = "Slightly Oversold";
    RsiGroupEnum["oversold"] = "Oversold";
    RsiGroupEnum["veryOversold"] = "Very Oversold";
})(RsiGroupEnum || (RsiGroupEnum = {}));
export var BarDirection;
(function (BarDirection) {
    BarDirection["long"] = "Long";
    BarDirection["short"] = "Short";
})(BarDirection || (BarDirection = {}));
export var SupportResistanceLevelType;
(function (SupportResistanceLevelType) {
    SupportResistanceLevelType["support"] = "Support";
    SupportResistanceLevelType["resistance"] = "Resistance";
})(SupportResistanceLevelType || (SupportResistanceLevelType = {}));
export var MarketCap;
(function (MarketCap) {
    MarketCap["megaCap"] = "Mega Cap";
    MarketCap["largeCap"] = "Large Cap";
    MarketCap["midCap"] = "Mid Cap";
    MarketCap["smallCap"] = "Small Cap";
    MarketCap["microCap"] = "Micro Cap";
    MarketCap["nanoCap"] = "Nano Cap";
})(MarketCap || (MarketCap = {}));
export var HighLowType;
(function (HighLowType) {
    HighLowType["high"] = "high";
    HighLowType["low"] = "low";
})(HighLowType || (HighLowType = {}));
//# sourceMappingURL=TechnicalAnalysis.js.map